import { __decorate, __metadata } from "tslib";
// NPM
import { Component, Mixins, Prop } from "vue-property-decorator";
import "vue-good-table/dist/vue-good-table.css";
import { VueGoodTable } from "vue-good-table";
// PALMATE
import BaseMixer from "@/router/views/BaseMixer";
import EcPaginate from "./EcPaginate.vue";
import Loader from "@/components/widgets/loader.vue";
import EcSelect from "./EcSelect.vue";
let EcGrid = /** @class */ (() => {
    let EcGrid = class EcGrid extends Mixins(BaseMixer) {
        onPageChange(params) {
            this.$emit("on-page-change", params);
        }
        onSortChange(params) {
            this.$emit("on-sort-change", params);
        }
        onColumnFilter(params) {
            this.$emit("on-column-filter", params);
        }
        onPerPageChange(params) {
            this.$emit("on-per-page-change", params);
        }
        selectionChanged(params) {
            this.$emit("on-selected-rows-change", params);
        }
        onDateChanged(item) {
            this.$emit("on-date-changed", item);
        }
    };
    __decorate([
        Prop(),
        __metadata("design:type", Object)
    ], EcGrid.prototype, "rows", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", Object)
    ], EcGrid.prototype, "columns", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", Object)
    ], EcGrid.prototype, "totalCount", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", Object)
    ], EcGrid.prototype, "page", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", Object)
    ], EcGrid.prototype, "pageSize", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", Object)
    ], EcGrid.prototype, "paginationOptions", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", Object)
    ], EcGrid.prototype, "sortOptions", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", Object)
    ], EcGrid.prototype, "isGridLoading", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", Object)
    ], EcGrid.prototype, "onRowClick", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", Object)
    ], EcGrid.prototype, "isFilterApplied", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", Object)
    ], EcGrid.prototype, "selectedDate", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", Object)
    ], EcGrid.prototype, "selectOptions", void 0);
    EcGrid = __decorate([
        Component({
            name: "EcGrid",
            components: {
                VueGoodTable,
                EcPaginate,
                Loader,
                EcSelect,
            },
        })
    ], EcGrid);
    return EcGrid;
})();
export default EcGrid;
